import { useTranslation } from 'react-i18next';
import { useSettings } from '../contexts/SettingsContext';

export function useSiteTranslation(ns?: string) {
  const { t, i18n } = useTranslation(ns);
  const { settings } = useSettings();
  const siteName = settings?.site?.name || t('common.siteNameFallback');

  const ts = (key: string, options?: Record<string, unknown>) =>
    t(key, { siteName, ...options });

  return { t, ts, i18n, siteName };
}
